import { Avatar, Stack, Typography } from '@mui/material'

import { theme } from 'styles/theme'

type MerchantBadgeProps = {
  name?: string | null
  logoUrl?: string | null
  size?: number
  // Sem nome ao lado, só o logo (ou a inicial)
  hideName?: boolean
  variant?: 'smLight' | 'smBold'
}

/**
 * SC-10999: identificação de uma empresa (logo, ou a inicial quando não há
 * logo, e o nome). Usado no seletor de contas, na coluna "Empresa" das listas
 * agregadas e no seletor de empresa dos formulários.
 */
const MerchantBadge = ({
  name,
  logoUrl,
  size = 24,
  hideName = false,
  variant = 'smLight'
}: MerchantBadgeProps) => {
  const initial = (name || '?').trim().charAt(0).toUpperCase()

  return (
    <Stack direction="row" alignItems="center" gap={1} minWidth={0}>
      <Avatar
        variant="rounded"
        src={logoUrl || undefined}
        alt={name || 'Empresa'}
        sx={{
          width: size,
          height: size,
          fontSize: Math.round(size * 0.45),
          fontWeight: 600,
          borderRadius: '6px',
          flexShrink: 0,
          bgcolor: theme.palette.neutral[800],
          color: theme.palette.neutral[300],
          border: `1px solid ${theme.palette.neutral[700]}`,
          '& img': { objectFit: 'contain' }
        }}
      >
        {initial}
      </Avatar>
      {!hideName && (
        <Typography variant={variant} noWrap title={name || undefined}>
          {name || '-'}
        </Typography>
      )}
    </Stack>
  )
}

export default MerchantBadge
